<template>
  <div>
    <sidebar-item
      :link="{
              name: 'Painel de notificações',
              icon: 'tim-icons icon-bell-55',
              path: {name: 'fintech.finance.panel_notification'}
            }"
      :notify="panel_notifications.length"
    />
    <sidebar-item
      :link="{
            name: $t('sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: {name: 'fintech.dashboard'}
          }"
    >
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([permission.FINANCE__OWNER.value, permission.FINANCE__ADMIN.value]) && $hasRole(role.FINTECH.value)"
      :link="{
            name: 'Configuração',
            icon: 'tim-icons icon-settings-gear-63',
            path: {name: 'fintech.finance.settings'}
          }"
    >
    </sidebar-item>
    <sidebar-item
      v-if="$canAny([permission.FINANCE__OWNER.value, permission.FINANCE__ADMIN.value])&& $hasRole(role.FINTECH.value)"
      :material=true
      :link="{
            name: this.$t('sidebar.users'),
            icon: 'group',
            path: {name: 'fintech.user'}
          }"
    >
    </sidebar-item>
    <sidebar-item
      :link="{
              name: 'Minhas Solicitações',
              icon: 'tim-icons icon-paper',
              path: {name: 'fintech.quotation'}
            }"
    >
    </sidebar-item>
  </div>
</template>

<script>
  import userRole from "@/util/valueObjects/userRole";
  import userPermission from "@/util/valueObjects/userPermission";

  export default {
    name: "Sidebar",
    props: {
      panel_notifications: {
        type: Array
      }
    },
    data(){
      return{
        role: userRole,
        permission: userPermission,
      }
    },
  }
</script>

<style scoped>

</style>
